<div mat-dialog-title class="mat-dialog-title">
How iRebal checks for wash sales
<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
</div>
<mat-dialog-content>
    <div class="mat-dialog-content">
        <div class="block" style="margin-top:20px;">
        Learn how iRebal checks for wash sales with each type of trade.
        </div>
        <div class="box-light-grey">

            <div class="block">
                <b>iRebal does not prevent wash sales</b><br>
                You are responsible for keeping track of account activity across your clients’ accounts.
            </div>
            <div class="block">
                 <b>iRebal does not make determinations about the appropriateness of alternative securities</b><br>
                 You are responsible for identifying alternative security investments that are not "substantially identical" for wash sale purposes.
            </div>
            <div class="block">
                   <b>iRebal only identifies wash sales arising from the purchase of the same security across accounts within the same portfolio.</b><br>
                   iRebal does not prevent wash sales at the household level or across accounts in separate portfolios, including certain tax-exempt accounts
            </div>
        </div>
        <hr style="border-top: solid 1px #cccccc;border-bottom: none;margin-bottom:12px;">
        <p><b>Buys</b></p>
        <div class="block"><irb-expando-link text="When a potential buy order is generated">
            <ul>
                <li>iRebal will check the order history to determine if the same security was sold through iRebal at a loss in the same portfolio within the last 30 days.</li>
            </ul>
        </irb-expando-link></div>
        <div class="block"><irb-expando-link text="If a loss is found">
            <ul>
                <li>The buy would be flagged as a potential wash sale. To mitigate wash sale concerns, iRebal will check to see if a primary or secondary wash sale alternate can be bought in its place.</li>
            </ul>
        </irb-expando-link></div>
        <div class="block"><irb-expando-link text="If neither wash sale alternate is available">
            <ul>
                <li>iRebal will either remove the buy or allow it, depending on settings.</li>
            </ul>
        </irb-expando-link></div>
        <div class="block"><irb-expando-link text="If the wash sale settings allow the buy">
            <ul>
                <li>This would result in a wash sale, potential deferring, nullifying, or permanently disallowing a loss.</li>
            </ul>
        </irb-expando-link></div>
        <hr style="border-top: solid 1px #cccccc;border-bottom: none;margin-bottom:12px;">
        <p><b>Sells</b></p>
        <div class="block"><irb-expando-link text="In taxable accounts, after generating sells for lots at a loss">
            <ul>
                <li>iRebal will check if there are any unsold lots of the same security in the portfolio that were purchased in the last 30 days. </li>
            </ul>
        </irb-expando-link></div>
        <div class="block"><irb-expando-link text="If sales at a loss are found">
            <ul>
                <li>A red “W” will appear as wash sale warning on the Rebalance Result Summary and on the Portfolio Result Details.</li>
            </ul>
        </irb-expando-link></div>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button (click)="close()" class="btn-medium-primary">Done</button>
</mat-dialog-actions>
